export default __webpack_public_path__ + "static/media/Meridian-150x150.bc78b2d6.png";